import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useDynamicReportApi } from '../../../services/api/dynamicReportApi/useDynamicReportApi';
import { useReportForceFetchFlag } from '../../campaigns/modules/campaigns-reports/hooks/useReportForceFetchFlag';
import { addIndication } from '../../taboola-common-frontend-modules/Indications';
import { useAccount } from '../../taboola-common-frontend-modules/account-configurations';
import { FormattedMessage } from '../../taboola-common-frontend-modules/i18n';
import { useModal } from '../../taboola-common-frontend-modules/modals';
import { getErrorIndication, getSuccessIndication } from './useDynamicReport';

export const useDeleteDynamicReport = () => {
    const dispatch = useDispatch();
    const { open: openModal } = useModal();
    const [, setForceFetchFlag] = useReportForceFetchFlag();
    const dynamicReportApi = useDynamicReportApi();
    const { accountName } = useAccount();
    const deleteReport = useCallback(
        async (reportId, reportName) => {
            const result = await openModal({
                title: (
                    <FormattedMessage
                        id="dynamic.reports.delete.report.confirmation.title"
                        defaultMessage="Delete report?"
                        tagName="h2"
                    />
                ),
                content: (
                    <FormattedMessage
                        id="dynamic.reports.delete.report.confirmation.message"
                        defaultMessage="You are about to delete report: {name}. Once a report is deleted, it can never run again."
                        values={{ name: <b>{reportName}</b> }}
                    />
                ),
                formProps: { submitButtonText: <FormattedMessage id="app.actionButtons.DELETE" /> },
            });

            if (!result) {
                return;
            }

            try {
                await dynamicReportApi.deleteReport(accountName, reportId);
                setForceFetchFlag(Date.now());
                dispatch(
                    addIndication(getSuccessIndication(reportName, 'dynamic.reports.dynamic.report.delete.success'))
                );
            } catch {
                dispatch(
                    addIndication(getErrorIndication(reportName, 'dynamic.reports.dynamic.report.delete.failure'))
                );
            }
        },
        [accountName, openModal, dynamicReportApi, dispatch, setForceFetchFlag]
    );

    return deleteReport;
};
